var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560"
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.show ? _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("신규 카테고리 등록")]), _c('v-card-text', [_c('category-select', {
    attrs: {
      "categories": _vm.categories,
      "return-object": "",
      "allowDepth": [1]
    },
    model: {
      value: _vm.editItem.parent,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "parent", $$v);
      },
      expression: "editItem.parent"
    }
  }), _c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "items": _vm.brands,
      "label": "브랜드",
      "multiple": "",
      "placeholder": " ",
      "item-text": "name",
      "item-value": "_id",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.brand,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "brand", $$v);
      },
      expression: "editItem.brand"
    }
  }), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "카테고리 이름(한국어)",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "name", $$v);
      },
      expression: "editItem.name"
    }
  }), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "카테고리 코드",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.code,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "code", $$v);
      },
      expression: "editItem.code"
    }
  })], 1), _c('v-card-title', {
    staticClass: "subtitle-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("아이콘")]), _c('v-card-text', [_c('product-image', {
    attrs: {
      "label": "아이콘1"
    },
    on: {
      "remove": _vm.removeThumb
    },
    model: {
      value: _vm.editItem.icon,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "icon", $$v);
      },
      expression: "editItem.icon"
    }
  }), _c('product-image', {
    attrs: {
      "label": "아이콘2"
    },
    on: {
      "remove": _vm.removeThumb
    },
    model: {
      value: _vm.editItem.icon2,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "icon2", $$v);
      },
      expression: "editItem.icon2"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("등록")])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }